var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	4914: () => (loadSingletonVersion("default", "react", false, [1,18,2,0], () => (__webpack_require__.e(5043).then(() => (() => (__webpack_require__(5043))))))),
	6672: () => (loadSingletonVersion("default", "react-dom", false, [1,18,2,0], () => (__webpack_require__.e(7950).then(() => (() => (__webpack_require__(7950))))))),
	4145: () => (loadStrictVersion("default", "i18next", false, [4,24,2,3], () => (__webpack_require__.e(4978).then(() => (() => (__webpack_require__(4978))))))),
	3434: () => (loadStrictVersion("default", "oidc-client-ts", false, [1,3,0,0], () => (__webpack_require__.e(248).then(() => (() => (__webpack_require__(248))))))),
	178: () => (loadStrictVersion("default", "axios-retry", false, [4,4,5,0], () => (__webpack_require__.e(199).then(() => (() => (__webpack_require__(199))))))),
	294: () => (loadStrictVersion("default", "@bimone/bimtrackreactcomponents", false, [4,31,7,0], () => (Promise.all([__webpack_require__.e(6910), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(6910))))))),
	2272: () => (loadStrictVersion("default", "immutable", false, [4,5,1,5], () => (__webpack_require__.e(2119).then(() => (() => (__webpack_require__(2119))))))),
	2803: () => (loadStrictVersion("default", "react-i18next", false, [4,15,4,1], () => (__webpack_require__.e(4117).then(() => (() => (__webpack_require__(4117))))))),
	4284: () => (loadStrictVersion("default", "@microsoft/applicationinsights-web", false, [4,3,3,3], () => (__webpack_require__.e(345).then(() => (() => (__webpack_require__(345))))))),
	7765: () => (loadStrictVersion("default", "uuid", false, [4,11,1,0], () => (__webpack_require__.e(1056).then(() => (() => (__webpack_require__(1056))))))),
	8281: () => (loadStrictVersion("default", "process", false, [4,0,11,10], () => (__webpack_require__.e(2285).then(() => (() => (__webpack_require__(2285))))))),
	9610: () => (loadStrictVersion("default", "redux", false, [4,5,0,1], () => (__webpack_require__.e(3923).then(() => (() => (__webpack_require__(3923))))))),
	2298: () => (loadStrictVersion("default", "react-router-dom", false, [4,7,12,0], () => (Promise.all([__webpack_require__.e(7874), __webpack_require__.e(263), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(263))))))),
	4294: () => (loadStrictVersion("default", "@casl/ability", false, [4,6,7,5], () => (__webpack_require__.e(2944).then(() => (() => (__webpack_require__(2944))))))),
	4929: () => (loadStrictVersion("default", "@reduxjs/toolkit", false, [4,2,1,0], () => (__webpack_require__.e(9277).then(() => (() => (__webpack_require__(9277))))))),
	5735: () => (loadStrictVersion("default", "@microsoft/signalr", false, [4,7,0,10], () => (__webpack_require__.e(8281).then(() => (() => (__webpack_require__(662))))))),
	9124: () => (loadStrictVersion("default", "@tanstack/react-query-devtools", false, [4,5,28,8], () => (__webpack_require__.e(2515).then(() => (() => (__webpack_require__(2515))))))),
	9342: () => (loadStrictVersion("default", "@tanstack/react-query", false, [4,5,28,4], () => (__webpack_require__.e(7297).then(() => (() => (__webpack_require__(7297))))))),
	9815: () => (loadStrictVersion("default", "use-debounce", false, [4,10,0,3], () => (__webpack_require__.e(589).then(() => (() => (__webpack_require__(2970))))))),
	1492: () => (loadStrictVersion("default", "@bimone/bimtrack-dates", false, [4,3,1,0], () => (Promise.all([__webpack_require__.e(8618), __webpack_require__.e(457)]).then(() => (() => (__webpack_require__(8618))))))),
	8874: () => (loadSingletonVersion("default", "styled-components", false, [1,5,3,5], () => (__webpack_require__.e(4685).then(() => (() => (__webpack_require__(4685))))))),
	3868: () => (loadSingletonVersion("default", "react-redux", false, [1,9,2,0], () => (__webpack_require__.e(3003).then(() => (() => (__webpack_require__(3003))))))),
	134: () => (loadStrictVersion("default", "axios", false, [4,1,13,5], () => (__webpack_require__.e(4344).then(() => (() => (__webpack_require__(4344))))))),
	2150: () => (loadStrictVersion("default", "react-virtualized-auto-sizer", false, [4,1,0,22], () => (__webpack_require__.e(3875).then(() => (() => (__webpack_require__(6256))))))),
	4050: () => (loadStrictVersion("default", "react-loading-skeleton", false, [4,3,4,0], () => (__webpack_require__.e(3372).then(() => (() => (__webpack_require__(3372))))))),
	6524: () => (loadStrictVersion("default", "tus-js-client", false, [4,4,3,1], () => (__webpack_require__.e(9866).then(() => (() => (__webpack_require__(9866))))))),
	9106: () => (loadSingletonVersion("default", "react-oidc-context", false, [1,3,0,0], () => (__webpack_require__.e(8423).then(() => (() => (__webpack_require__(804))))))),
	457: () => (loadSingletonVersion("default", "moment-timezone", false, [2,0,5,45], () => (__webpack_require__.e(4348).then(() => (() => (__webpack_require__(4348))))))),
	3688: () => (loadStrictVersion("default", "react-copy-to-clipboard", false, [4,5,1,0], () => (__webpack_require__.e(9095).then(() => (() => (__webpack_require__(1476)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"457": [
		457
	],
	"2524": [
		178,
		294,
		2272,
		2803,
		4284,
		7765,
		8281
	],
	"3434": [
		3434
	],
	"3868": [
		3868
	],
	"4145": [
		4145
	],
	"4193": [
		2298,
		4294,
		4929,
		5735,
		9124,
		9342,
		9815
	],
	"4914": [
		4914
	],
	"5105": [
		3688
	],
	"5509": [
		1492,
		8874
	],
	"6672": [
		6672
	],
	"7031": [
		134,
		2150,
		4050,
		6524,
		9106
	],
	"9610": [
		9610
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}